import { IUserContext, userContext } from "capsule"
import _ from "lodash"
import React, { FC, useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { HomeNS } from "../../features/i18n/constants"
import { getPatientCurrentDateSessions } from "../../features/models/PhaseAndSessionFunctions"
import { FirestoreSession } from "../../features/models/Session"
import { AppUserData } from "../../features/models/UserData"
import { programContext } from "../../features/Providers/ProgramProvider"
import HomeOncoView from "./HomeOncoView"
import HomeOrthoView from "./HomeOrthoView"
import HomeSectionHeader from "./HomeSectionHeader"

const HomeSessionView: FC = () => {
  const { t } = useTranslation(HomeNS)
  const { userData, userDocRef } = useContext<IUserContext<AppUserData>>(userContext)
  const { currentSession, phaseExercises } = useContext(programContext)
  const [sessionDocuments, setSessionDocuments] = useState<FirestoreSession[]>([])
  const isOnco = userData?.specialty === "onco"

  useEffect(() => {
    const fetchData = async () => {
      if (userDocRef?.id) {
        const sessions = await getPatientCurrentDateSessions(userDocRef.id)
        setSessionDocuments(sessions)
      }
    }
    fetchData()
  }, [userDocRef?.id, currentSession])

  const recurrenceMax = _.maxBy(phaseExercises, ex => ex.recurrence)?.recurrence ?? 0
  const completedSessions = sessionDocuments.length
  const isEmptyExo = _.isEmpty(phaseExercises)

  let title = t("nextTime")

  if (!isEmptyExo && completedSessions < recurrenceMax && currentSession) {
    title = `${t("nextTime")} (${completedSessions + 1}/${recurrenceMax})`
  }

  return (
    <>
      <HomeSectionHeader title={title} />
      {isOnco ? <HomeOncoView /> : <HomeOrthoView />}
    </>
  )
}

export default HomeSessionView
